import { useTranslation } from "react-i18next";

import { Text } from "chameleon/lib/components";

import { FormTitle } from "checkout-experience/components/forms/form-title";
import { useChexContext } from "checkout-experience/providers/chex-context-wrapper";

const ContactInfo = () => {
  const { t } = useTranslation(["combined"]);
  const { experienceType, checkoutSession } = useChexContext();
  const { contactInformation } = checkoutSession ?? {};
  const { shopperEmail, shopperPhoneNumber } = contactInformation || {};

  return (
    <>
      <span id="contactSectionHeaderId" hidden>
        {t("contactInformation")}
      </span>
      <FormTitle title={t("contactInformation")} />
      <div>
        <Text styleVariant="body">
          {shopperEmail || t("error.no-email-listed")}
        </Text>
        {experienceType !== "hppLink" && (
          <Text styleVariant="body" tagElement="p">
            {shopperPhoneNumber &&
            shopperPhoneNumber.length > 0 &&
            shopperPhoneNumber.find((item) => item !== undefined && item !== "")
              ? shopperPhoneNumber.find(
                  (item) => item !== undefined && item !== ""
                )
              : t("error.no-phone-number-listed")}
          </Text>
        )}
      </div>
    </>
  );
};

export default ContactInfo;
